import React from 'react';
import '../../../styles.css';
// import simg from '../../../assets/animals/S/snake.png'
// import mimg from '../../../assets/animals/M/monkey.png'
// import timg from '../../../assets/animals/T/turtle.png'
// import pimg from '../../../assets/animals/P/panda.png';
// import nimg from '../../../assets/animals/N/narwhal.png';
// import cimg from '../../../assets/animals/C/cat.png';
// import kimg from '../../../assets/animals/K/kangaroo.png';
// import rimg from '../../../assets/animals/R/rhinoceros.png';
// import bimg from '../../../assets/animals/B/bee.png';
// import jimg from '../../../assets/animals/J/jellyfish.png';
// import fimg from '../../../assets/animals/F/fish.png';
// import gimg from '../../../assets/animals/G/gorilla.png';
// import himg from '../../../assets/animals/H/hippopotamus.png';
// import dimg from '../../../assets/animals/D/duck.png';
// import wimg from '../../../assets/animals/W/wolf.png';
// import vimg from '../../../assets/animals/V/vulture.png';
// import limg from '../../../assets/animals/L/lion.png';
// import yimg from '../../../assets/animals/Y/yak.png';
import simg from '../../../assets/real_assets/s.jpg'
import mimg from '../../../assets/real_assets/m.jpg'
import timg from '../../../assets/real_assets/t.jpg'
import pimg from '../../../assets/real_assets/p.jpg'
import nimg from '../../../assets/real_assets/n.jpg'
import cimg from '../../../assets/real_assets/c.jpg'
import kimg from '../../../assets/real_assets/k.jpg'
import rimg from '../../../assets/real_assets/r.jpg'
import bimg from '../../../assets/real_assets/b.jpg'
import jimg from '../../../assets/real_assets/j.jpg'
import fimg from '../../../assets/real_assets/f.jpg'
import gimg from '../../../assets/real_assets/g.jpg'
import himg from '../../../assets/real_assets/h.jpg'
import dimg from '../../../assets/real_assets/d.jpg'
import wimg from '../../../assets/real_assets/w.jpg'
import vimg from '../../../assets/real_assets/v.jpg'
import limg from '../../../assets/real_assets/l.jpg'
import yimg from '../../../assets/real_assets/y.jpg'
// import aimg from '../../../assets/animals/A/ant.png';
// import chimg from '../../../assets/animals/CH/chicken.png';
// import eimg from '../../../assets/animals/E/elephant.png';
// import iimg from '../../../assets/animals/I/iguana.png';
// import oimg from '../../../assets/animals/O/octopus.png';
// import shimg from '../../../assets/animals/SH/sheep.png';
// import zimg from '../../../assets/animals/Z/zebra.png';

const animalImages = {
    's': simg,
    'm': mimg,
    't': timg,
    'p': pimg,
    'n': nimg,
    'c': cimg,
    'k': kimg,
    'r': rimg,
    'b': bimg,
    'j': jimg,
    'f': fimg,
    'g': gimg,
    'h': himg,
    'd': dimg,
    'w': wimg,
    'v': vimg,
    'l': limg,
    'y': yimg
}

function AnimalAnswerButton(props) {

    if (props.submitState === 0) {
        props.setCorrectDialogue()
        if (props.currentlyClicked === props.id) {
            return(
                <button className={'selectedAnswerButton'}>
                    <img className='photographsInDivs' onClick={() => props.stateChanger(props.id)} src={animalImages[props.letter]} id={props.letter} alt='Letter' />
                </button>
            )
        } else {
            return (
                <button className={'answerButton'}>
                    <img className='photographsInDivs' onClick={() => props.stateChanger(props.id)} src={animalImages[props.letter]} id={props.letter} alt='Letter' />
                </button>
            );        
        }
    } else if (props.submitState === 1) {
        if (props.correctLetter === (props.id-1)) {
            return (
                <button className={'selectedAnswerButton'} style={{borderColor:'#04cc00'}}>
                    <img className='photographsInDivs' src={animalImages[props.letter]} id={props.letter} alt='Letter' />
                </button>
            )
        } else if (props.currentlyClicked === props.id) {
            props.setIncorrectDialogue()
            return (
                <button className={'selectedAnswerButton'} style={{borderColor:'#ff000f'}}>
                    <img className='photographsInDivs' src={animalImages[props.letter]} id={props.letter} alt='Letter' />
                </button>
            )
        } else {
            return (
                <button className={'answerButton'}>
                    <img className='photographsInDivs' src={animalImages[props.letter]} id={props.letter} alt='Letter' />
                </button>
            ) 
        }
    }

}

export default AnimalAnswerButton;